const context = '[Site Context]';

export enum SITE_CONTEXT_ACTIONS {
  LOAD_COUNTRIES = `${context} LOAD_COUNTRIES`,
  LOAD_COUNTRIES_SUCCESS = `${context} LOAD_COUNTRIES_SUCCESS`,

  SET_COUNTRY_CODE = `${context} SET_COUNTRY_CODE`,

  TOGGLE_EDIT_BAR_VISIBILITY = `${context} TOGGLE_EDIT_BAR_VISIBILITY`,

  GET_LANGUAGES = `${context} GET_LANGUAGES`,
  LOAD_LANGUAGES = `${context} LOAD_LANGUAGES`,
  LOAD_LANGUAGES_SUCCESS = `${context} LOAD_LANGUAGES_SUCCESS`,

  CHANGE_COUNTRY = `${context} CHANGE_COUNTRY`,
}
